import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { reset_password_user_action } from "../../../redux/_actions";
// import { validateEmail } from "../../../_helpers/validators";

function useForgotPassword() {
  const [formData, setformData] = useState({});
  const [formInputsError, setFormInputsError] = useState({});
  const [loading, setloading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [redirectTimer, setredirectTimer] = useState(5);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  //initiate form data
  React.useEffect(() => {
    setformData({
      email: "",
    });
  }, []);

  //change inputs
  const onInputChange = (value, key) => {
    let data = formData;
    data[key] = value;
    setformData(data);
  };

  // email submit button
  const onSubmitClick = async (e) => {
    setloading(true);
    if (validateForm()) {
      const res = await dispatch(reset_password_user_action(formData));
      // navigate or show error
      checkNavigate(res);
      setFormInputsError({})
    }

    setloading(false);
  };

  // navigate to screens
  const checkNavigate = (res) => {
    if (res !== undefined) {
      setEmailSent(true);
      setTimeout(() => {
        navigate("/sign-in");
      }, 5000);
      let timer = setInterval(() => {
        setredirectTimer((redirectTimer) => redirectTimer - 1);
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    } else {
      let form_errors = {
        formSubmitError: "Can not send email to the given email id.",
      };
      setFormInputsError(form_errors);
    }
  };

  // validate form
  const validateForm = () => {
    let form_errors = {};

    //validate email
    if (formData.email.length === 0) {
      form_errors = {
        email: "Email cannot be empty",
      };
      setFormInputsError(form_errors);
      return false;
    }
    // if (validateEmail(formData.email)) {
    //   form_errors = {
    //     email: "Enter valid email",
    //   };
    //   setFormInputsError(form_errors);
    //   return false;
    // }
    return true;
  };

  return {
    loading,
    formInputsError,
    emailSent,
    redirectTimer,
    formData,

    onInputChange,
    onSubmitClick,
  };
}

export default useForgotPassword;
